import React from 'react';
import { Shield, CheckCircle2, TrendingUp, Clock, Building2, ArrowRight } from 'lucide-react';

const BusinessTradelinesPage = () => {
  const businessTradeline = {
    id: 1,
    title: "$100,000 Business Tradeline",
    description: "Establish a powerful $100,000 business tradeline that reports directly to business credit bureaus. This high-limit tradeline is placed in your BUSINESS name, building your company's credit profile independently from your personal credit. Perfect for entrepreneurs seeking significant business funding, SBA loans, or business lines of credit. Our business tradelines report to Dun & Bradstreet, Experian Business, and Equifax Business, establishing the credit history lenders want to see. This is the fastest way to position your business for 7 and 8-figure funding approvals.",
    features: [
      "$100,000 Credit Limit",
      "Reports to Business Credit Bureaus",
      "Dun & Bradstreet Reporting",
      "Experian Business Reporting",
      "Equifax Business Reporting",
      "Builds Business Credit Profile",
      "Separate from Personal Credit",
      "Positions for 7 & 8-Figure Funding"
    ],
    paymentLink: "https://www.fanbasis.com/agency-checkout/THEACADEMYCEO/ROL8L"
  };

  return (
    <div className="dark-page tradelines-page">
      {/* Hero Section */}
      <section className="tradelines-hero">
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">BUSINESS CREDIT</div>
          <h1 className="display-huge tradelines-title">
            <span className="text-gradient">Business</span> Tradelines
          </h1>
          <p className="body-large tradelines-subtitle">
            Build your business credit profile with high-limit tradelines that report to all major 
            business credit bureaus. Position your company for significant funding approvals.
          </p>
          
          <div className="tradelines-features-row">
            <div className="tradeline-feature-item">
              <Building2 size={24} />
              <span>Business Credit Bureaus</span>
            </div>
            <div className="tradeline-feature-item">
              <TrendingUp size={24} />
              <span>7 & 8-Figure Positioning</span>
            </div>
            <div className="tradeline-feature-item">
              <Shield size={24} />
              <span>Separate from Personal</span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Banner */}
      <div className="guarantee-banner">
        <div className="guarantee-content">
          <CheckCircle2 size={24} />
          <p>Reports to Dun & Bradstreet, Experian Business, and Equifax Business</p>
        </div>
      </div>

      {/* Business Tradeline Card */}
      <section className="tradelines-grid-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Premium Business Tradeline</h2>
          <p className="body-medium section-description">
            Establish serious business credit with our premium business tradeline
          </p>
        </div>
        
        <div className="business-tradeline-container">
          <div className="business-tradeline-card" data-testid="business-tradeline-card">
            <div className="business-tradeline-header">
              <div className="business-tradeline-amount">$100,000</div>
              <div className="business-tradeline-label">Business Credit Limit</div>
            </div>
            
            <h3 className="business-tradeline-title">{businessTradeline.title}</h3>
            <p className="business-tradeline-description">{businessTradeline.description}</p>
            
            <div className="business-tradeline-features">
              {businessTradeline.features.map((feature, idx) => (
                <div key={idx} className="business-feature-item">
                  <CheckCircle2 size={18} />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <a 
              href={businessTradeline.paymentLink}
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-primary business-tradeline-btn"
              data-testid="business-tradeline-buy-btn"
            >
              Learn More
              <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="position-explainer">
        <div className="section-header">
          <h2 className="display-medium section-title">Why Business Tradelines?</h2>
          <p className="body-medium section-description">
            Separate your business credit from your personal credit
          </p>
        </div>
        
        <div className="process-steps">
          <div className="process-step">
            <div className="process-step-number">1</div>
            <div className="process-step-content">
              <h3>Build Business Credit Fast</h3>
              <p>Establish a strong business credit profile quickly with a high-limit tradeline that reports to all major business bureaus.</p>
            </div>
          </div>
          <div className="process-step">
            <div className="process-step-number">2</div>
            <div className="process-step-content">
              <h3>Protect Personal Credit</h3>
              <p>Keep your personal and business finances separate. Business tradelines build your company's credit without affecting your personal score.</p>
            </div>
          </div>
          <div className="process-step">
            <div className="process-step-number">3</div>
            <div className="process-step-content">
              <h3>Unlock Business Funding</h3>
              <p>Position your business for SBA loans, business lines of credit, equipment financing, and other funding opportunities that require established business credit.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready to Build Your Business Credit?</h2>
          <p className="body-large">
            Take your business to the next level with a $100,000 business tradeline that positions you for serious funding.
          </p>
          <a 
            href="https://calendly.com/thecollinsacademynew/30min" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary"
          >
            Schedule Consultation
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default BusinessTradelinesPage;
